/**
 *  using pinia to proxy the reactive user object so we can safely use it outside an effect scope (e.g. in a normal function call somewhere in utils)
 * */
export const useAuthStore = defineStore("auth", () => {
  const { user } = useCurrentUser();
  return { user };
});
